import { useEffect, useRef } from "react";
import { motion, useMotionValue, useTransform, animate, useInView } from "framer-motion";

export default function RollingNumber({ value, duration = 2, suffix = "" }) {
  const count = useMotionValue(0);
  const rounded = useTransform(count, (latest) => Math.round(latest));
  
  const ref = useRef(null);
  // once: true is good—it prevents the animation from resetting if you scroll up/down
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  useEffect(() => {
    if (isInView) {
      const controls = animate(count, value, {
        duration: duration,
        ease: "easeOut",
      });
      return controls.stop;
    }
  }, [count, value, duration, isInView]);

  return (
    // Changed outer element to div for valid nesting
    // Added inline-flex so it stays on one line like text
    <h1 ref={ref} className="rolling-animation">
      <motion.span className="rolling-animation-value">
        {rounded}
      </motion.span>
      {suffix && <span className="rolling-animation-suffix">{suffix}</span>}
    </h1>
  );
}